import React, {useState,useEffect,useCallback} from 'react';
//import {Link} from 'react-router-dom'//yarn add @types/react-router-dom
import { useCookies } from 'react-cookie';
import useStyles from './Styles';
import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
//import Table from '@mui/material/Table';
//import TableBody from '@mui/material/TableBody';
//import List from '@mui/material/List';
//import ListItem from '@mui/material/ListItem';
//import ListItemIcon from '@mui/material/ListItemIcon';
//import ListItemText from '@mui/material/ListItemText';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
//import VisibilityIcon from '@mui/icons-material/Visibility';
//import AccountBoxIcon from '@mui/icons-material/AccountBox';
//import BookIcon from '@mui/icons-material/Book';
//import CheckIcon from '@mui/icons-material/Check';
//import LaunchIcon from '@mui/icons-material/Launch';
//import MessageIcon from '@mui/icons-material/Assignment';
//import CopyToClipboard from 'react-copy-to-clipboard';
//import MultiLines from './MultiLines';
import RowData from './RowData';
import BottomButtons from './BottomButtons';
import {Inc,Owner,CookieHashName} from './Inc';
//import StoreImg from './StoreImg';
//import RowTable from './RowTable';
import Ajax from './Ajax';
import Loading from './Loading';
import Toast from './Toast';
//import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import Title from './Title';


interface CustomerDetailProps {
	owner:Owner,
}

const CustomerDetail = (props:CustomerDetailProps)=> {
    Ajax.setEditorId( props.owner.owner_id );
	const [cookies, setCookie, removeCookie] = useCookies(['customer_id']);

    const classes = useStyles();
    const [states,setStates] = useState({
        customer: Inc.defaultCustomer(),
        isLoading:true,
    });
	const [toast,setToast] = useState('');
	//const copy = ()=>{
	//	setToast('クリップボードにURLをコピーしました');
	//}
	//const dummy = ()=>{
		
	//}
	const closeToast = ()=>{
		setToast('');
	}
	const readCookie = useCallback(()=>{
		//console.log("cookies",cookies);
		let cookieData:{[key:string]:string;} = {};
		if( cookies[CookieHashName] ){
			//console.log("readCookie",cookies[CookieHashName]);
			const lines = cookies[CookieHashName].split(/\n/);
			for( let i=0 ; i<lines.length ; i++ ){
				const sp = lines[i].split(/\t/);
				cookieData[ sp[0] ] = sp[1];
			}
		} else {
			//localStorage.removeItem('ownerId');
		}
		return cookieData;
	},[cookies]);

    useEffect( ()=>{
		window.scrollTo(0,0);
		const cookieData = readCookie();
        if( cookieData.customer_id ){
            Ajax.send("profile/customer",{customer_id:cookieData.customer_id},(res:any)=>{
                if( res.ok ){
                    setStates({...states,"isLoading":false,"customer":Inc.convCustomer(res.customer)})
                }
            });
        } else {
            setStates({...states,"isLoading":false});
        }
    } ,[]);

    if( states.isLoading ){
        return (
            <Loading isLoading={true}/>
        )
    }

	const toMypage = process.env.REACT_APP_STOREURL + "/mypage_index.html";

	return (
		<div id="profile_detail" className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={9}>
                    <Paper className={classes.paper}>
                        <Title text="連絡先" second="（会員登録）" icon="portrait"/>
						<div style={{marginBottom:"2em"}}>
						連絡先（会員登録）の修正はSideBではなく架空ストアのマイページで行います。<br/>
						委託終了時の商品の返送先や重要なお知らせなどで利用しますので、登録内容に間違いがないようご注意ください。<br/>
						</div>
						<Hidden mdUp implementation="js">
							<BottomButtons button1='マイページへ行く' href1={toMypage} icon1={<ArrowForwardIcon/>}/>
						</Hidden>

						<Divider style={{marginBottom:"1em"}}/>
						{states.customer.name!=='' ? (
						<Grid container spacing={1}>
							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>名前</div>
							</Grid>
							<Grid item xs={12} sm={9} md={8}>
								{states.customer.name}（{states.customer.kana}）
							</Grid>
							<Grid item xs={12}>
								<Divider className="formValidator"/>
							</Grid>
							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>メールアドレス</div>
							</Grid>
							<Grid item xs={12} sm={9} md={8}>
								{states.customer.mail}
							</Grid>
							<Grid item xs={12}>
								<Divider className="formValidator"/>
							</Grid>
							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>電話番号</div>
							</Grid>
							<Grid item xs={12} sm={9} md={8}>
								{states.customer.tel}
							</Grid>
							<Grid item xs={12}>
								<Divider className="formValidator"/>
							</Grid>
							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>住所</div>
							</Grid>
							<Grid item xs={12} sm={9} md={8}>
								〒{states.customer.zip}<br/>
								{states.customer.addr}
							</Grid>
							<Grid item xs={12}>
								<Divider className="formValidator"/>
							</Grid>
						</Grid>
						):(
							<Grid container spacing={1}>
							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>名前</div>
							</Grid>
							<Grid item xs={12} sm={9} md={8}>
								未設定
							</Grid>
							<Grid item xs={12}>
								<Divider className="formValidator"/>
							</Grid>
							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>メールアドレス</div>
							</Grid>
							<Grid item xs={12} sm={9} md={8}>
								{states.customer.mail}
							</Grid>
							<Grid item xs={12}>
								<Divider className="formValidator"/>
							</Grid>
							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>電話番号</div>
							</Grid>
							<Grid item xs={12} sm={9} md={8}>
								未設定
							</Grid>
							<Grid item xs={12}>
								<Divider className="formValidator"/>
							</Grid>
							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>住所</div>
							</Grid>
							<Grid item xs={12} sm={9} md={8}>
								未設定
							</Grid>
							<Grid item xs={12}>
								<Divider className="formValidator"/>
							</Grid>
						</Grid>
						)}
                    </Paper>
                </Grid>
                <Grid item xs={12} md={3}>
                    <Paper className={classes.paper}>
                        <Title text="管理情報" size={2}/>
						<RowData name="ログイン方法" value={states.customer.auth_type}/>
						<RowData name="登録日" value={states.customer.regist_date}/>

						<Divider style={{margin:"1em 0",marginTop:'0.5em'}}/>
						<Hidden mdDown implementation="js">
							<FormControl fullWidth={true} style={{marginBottom:"1em"}}>
								<a href={toMypage}><Button variant="contained" color="primary" style={{width:"100%"}}><ArrowForwardIcon style={{marginRight:"0.5em"}}/>マイページへ行く</Button></a>
							</FormControl>
						</Hidden>

                        <ul style={{paddingLeft:"1.5em",paddingRight:"0.5em"}}>
							<li>マイページではログイン方法の変更も可能です。</li>
                        </ul>

                    </Paper>
                </Grid>
            </Grid>
			<Toast mes={toast} close={closeToast}/>
		</div>
	);
}

export default CustomerDetail;
